(function () {
  'use strict';

  var IMAGE_SELECTOR = 'img[data-header-image]';
  var SCOPE_SELECTOR = '[data-header-image-scope]';

  function isShopifyImage(url) {
    return (
      url.hostname === 'cdn.shopify.com' ||
      url.hostname.endsWith('.myshopify.com') ||
      url.hostname === window.location.hostname ||
      url.pathname.indexOf('/cdn/shop/') !== -1
    );
  }

  function sizedUrl(rawUrl, width) {
    try {
      var url = new URL(rawUrl, document.baseURI);

      if (!isShopifyImage(url)) {
        return rawUrl;
      }

      url.searchParams.set('width', String(width));
      return url.href;
    } catch (error) {
      return rawUrl;
    }
  }

  function parseWidths(value) {
    var widths = (value || '360,540')
      .split(',')
      .map(function (width) {
        return parseInt(width, 10);
      })
      .filter(function (width) {
        return Number.isFinite(width) && width > 0;
      })
      .sort(function (a, b) {
        return a - b;
      });

    return widths.length ? widths : [360, 540];
  }

  function hydrateImage(image) {
    if (image.dataset.headerImageLoaded === 'true') return;

    var rawUrl = image.getAttribute('data-header-image');
    if (!rawUrl) return;

    var widths = parseWidths(image.getAttribute('data-header-widths'));
    var candidates = widths.map(function (width) {
      return sizedUrl(rawUrl, width);
    });
    var canResize = candidates.some(function (candidate) {
      return candidate !== rawUrl;
    });

    image.dataset.headerImageLoaded = 'true';
    image.loading = 'eager';
    image.decoding = 'async';

    if (canResize) {
      image.sizes = image.getAttribute('data-header-sizes') || '(max-width: 989px) 50vw, 360px';
      image.srcset = candidates
        .map(function (candidate, index) {
          return candidate + ' ' + widths[index] + 'w';
        })
        .join(', ');
      image.src = candidates[0];
    } else {
      image.src = rawUrl;
    }
  }

  function hydrate(scope) {
    if (!scope || scope.dataset.headerImagesLoaded === 'true') return;

    scope.dataset.headerImagesLoaded = 'true';
    scope.querySelectorAll(IMAGE_SELECTOR).forEach(hydrateImage);
  }

  function bindScope(scope) {
    if (!scope || scope.dataset.headerImageEventsBound === 'true') return;

    scope.dataset.headerImageEventsBound = 'true';

    if (scope.classList.contains('menu-item')) {
      scope.addEventListener('mouseenter', function () {
        hydrate(scope);
      });
      scope.addEventListener('focusin', function () {
        hydrate(scope);
      });
      return;
    }

    var details = scope.querySelector('details');
    if (!details) return;

    details.addEventListener('toggle', function () {
      if (details.open) hydrate(scope);
    });

    if (details.open) hydrate(scope);
  }

  function bindScopes(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    if (root.matches && root.matches(SCOPE_SELECTOR)) bindScope(root);
    root.querySelectorAll(SCOPE_SELECTOR).forEach(bindScope);
  }

  bindScopes(document);

  document.addEventListener('shopify:section:load', function (event) {
    bindScopes(event.target);
  });

  window.HeaderMenuImages = {
    hydrate: hydrate,
    bind: bindScopes,
  };
})();
